import { StyledLoading } from "./styles";

export const Loading = () => {
  return (
    <StyledLoading>
      <div></div>
    </StyledLoading>
  );
};
